export default "__VITE_ASSET__3194879d__"